import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ReactAudioPlayer from "react-audio-player";
import Recorder from "./Recorder";
import { RecordingContext } from "../pages/RecordingPage";
import { HOST_URL } from "../../constants";

const RecorderArea = ({ time }) => {
  const {
    recording,
    createRecording,
    tgtPlayerRef,
    srcPlayerRef,
    recBtnRef,
  } = useContext(RecordingContext);
  const [srcRec, setSrcRec] = useState();
  const reviewer = useSelector((state) => state.mode.reviewer);
  useEffect(
    () => {
      const srcRecUrl = recording.tmpUrl
        ? recording.tmpUrl
        : urlFromKey(recording.user_key)
        ? // query parameter is here to force browsers to re-download audio from url every time
          // and not to use their hidden 'cache'
          // `${recording.user_key}?cb=${new Date().getTime()}`
          `${urlFromKey(recording.user_key)}?cb=${time}`
        : "";
      setSrcRec(srcRecUrl);
    },
    // eslint-disable-next-line
    [recording, reviewer]
  );
  const urlFromKey = (key) => {
    if (!key) return null;
    return `${HOST_URL}/s3/${key}`;
  };
  return (
    <>
      <ReactAudioPlayer
        controls
        src={urlFromKey(recording.reference_key)}
        style={playerStyle}
        ref={tgtPlayerRef}
        // preload="auto"
      />
      {!reviewer && (
        <Recorder onRecordingReady={createRecording} recBtnRef={recBtnRef} />
      )}
      <ReactAudioPlayer
        controls
        src={srcRec}
        title={srcRec}
        style={playerStyle}
        ref={srcPlayerRef}
      />
      <link rel="prefetch" href={urlFromKey(recording.reference_key)} />
      {reviewer && (
        <link rel="prefetch" href={urlFromKey(recording.user_key)} />
      )}
    </>
  );
};

const playerStyle = {
  display: "block",
  margin: "10px 0",
};

RecorderArea.propTypes = {
  time: PropTypes.number.isRequired,
};

export default RecorderArea;
